'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import iconLogOut from '../../../assets/img/account/logout@2x.png';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _components = require('components');

var _package = require('../../../../package.json');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _voucher = require('redux/modules/voucher');

var vouchersAction = _interopRequireWildcard(_voucher);

var _edit2x = require('assets/img/account/edit@2x.png');

var _edit2x2 = _interopRequireDefault(_edit2x);

var _history2x = require('assets/img/account/history@2x.png');

var _history2x2 = _interopRequireDefault(_history2x);

var _calendar2x = require('assets/img/account/calendar@2x.png');

var _calendar2x2 = _interopRequireDefault(_calendar2x);

var _newShop2x = require('assets/img/account/newShop@2x.png');

var _newShop2x2 = _interopRequireDefault(_newShop2x);

var _activityRule3x = require('assets/img/policy/activityRule@3x.png');

var _activityRule3x2 = _interopRequireDefault(_activityRule3x);

var _contactInfo3x = require('assets/img/policy/contactInfo@3x.png');

var _contactInfo3x2 = _interopRequireDefault(_contactInfo3x);

var _hammer3x = require('assets/img/policy/hammer@3x.png');

var _hammer3x2 = _interopRequireDefault(_hammer3x);

var _policy3x = require('assets/img/policy/policy@3x.png');

var _policy3x2 = _interopRequireDefault(_policy3x);

var _rewardPoint2x = require('assets/img/account/rewardPoint@2x.png');

var _rewardPoint2x2 = _interopRequireDefault(_rewardPoint2x);

var _rewardBenefit2x = require('assets/img/account/rewardBenefit@2x.png');

var _rewardBenefit2x2 = _interopRequireDefault(_rewardBenefit2x);

var _currentReward2x = require('assets/img/account/currentReward@2x.png');

var _currentReward2x2 = _interopRequireDefault(_currentReward2x);

var _myVoucher2x = require('assets/img/account/myVoucher@2x.png');

var _myVoucher2x2 = _interopRequireDefault(_myVoucher2x);

var _paymentListIcon3x = require('assets/img/payment/paymentListIcon@3x.png');

var _paymentListIcon3x2 = _interopRequireDefault(_paymentListIcon3x);

var _feedback2x = require('assets/img/account/feedback@2x.png');

var _feedback2x2 = _interopRequireDefault(_feedback2x);

var _app2x = require('assets/img/account/app@2x.png');

var _app2x2 = _interopRequireDefault(_app2x);

var _homeSlide = require('assets/img/home/home-slide-1.jpg');

var _homeSlide2 = _interopRequireDefault(_homeSlide);

var _homeSlide3 = require('assets/img/home/home-slide-2.jpg');

var _homeSlide4 = _interopRequireDefault(_homeSlide3);

var _homeSlide5 = require('assets/img/home/home-slide-3.jpg');

var _homeSlide6 = _interopRequireDefault(_homeSlide5);

var _support = require('helpers/support');

var _Constant = require('helpers/Constant');

var _Constant2 = _interopRequireDefault(_Constant);

var _lib = require('helpers/lib');

require('firebase/auth');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var slides = [_homeSlide2.default, _homeSlide4.default, _homeSlide6.default];

var AccountMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    MY_REWARD_LIST: state.voucher.MY_REWARD_LIST
  };
}, (0, _extends3.default)({}, authActions, vouchersAction, {
  pushState: _reactRouterRedux.push,
  getMyReward: vouchersAction.getMyReward
})), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(AccountMobile, _Component);

  function AccountMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AccountMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AccountMobile.__proto__ || (0, _getPrototypeOf2.default)(AccountMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      coverIndex: Math.floor(Math.random() * slides.length),
      newUser: {
        _id: _this.props.user ? _this.props.user._id : null,
        email: _this.props.user ? _this.props.user.email : null,
        name: _this.props.user ? _this.props.user.profile.name : null,
        avatar: _this.props.user ? _this.props.user.profile.picture : null,
        dob: _this.props.user ? _this.props.user.profile.dob : null,
        phone: _this.props.user ? _this.props.user.phone : null,
        gender: _this.props.user ? _this.props.user.profile.gender : null,
        isUpdatedAvatar: false
      },
      avatar: []
    }, _this.handleLogout = function () {
      _this.props.logout();
    }, _this.renderPolicyItems = function (styles) {
      return _react2.default.createElement(
        'div',
        { className: styles.accountLink },
        _react2.default.createElement(_components.AccountItem, {
          link: '/chinh-sach/thong-tin-lien-he',
          icon: _contactInfo3x2.default,
          title: 'Thông tin liên hệ'
        }),
        _react2.default.createElement(_components.AccountItem, {
          link: '/chinh-sach/quy-che-hoat-dong',
          icon: _activityRule3x2.default,
          title: 'Quy chế hoạt động'
        }),
        _react2.default.createElement(_components.AccountItem, {
          link: '/chinh-sach/giai-quyet-tranh-chap',
          icon: _hammer3x2.default,
          title: 'Quy trình giải quyết tranh chấp'
        }),
        _react2.default.createElement(_components.AccountItem, {
          link: '/chinh-sach/bao-mat',
          icon: _policy3x2.default,
          title: 'Chính sách bảo mật'
        })
      );
    }, _this.renderLoggedIn = function (styles, objUser, objRank, avatarUrl, myVoucherAmount) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.thumbnailContainer },
          _react2.default.createElement(
            'div',
            { className: styles.avatar },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/chinh-sua-tai-khoan' },
              _react2.default.createElement('img', {
                src: avatarUrl,
                style: { backgroundImage: 'url:(' + avatarUrl + ')' },
                className: styles.avatarImg
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.userInfo },
              _react2.default.createElement(
                'div',
                { className: styles.nameView },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/chinh-sua-tai-khoan', className: styles.name },
                  objUser.name
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/chinh-sua-tai-khoan', className: styles.name },
                  _react2.default.createElement('img', { src: _edit2x2.default })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.memberView },
                _react2.default.createElement('img', { src: objRank.imageRank, className: styles.starImg }),
                _react2.default.createElement(
                  'div',
                  { className: styles.memberStatus },
                  objRank.label
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'div',
            { className: styles.accountLink },
            _react2.default.createElement(_components.AccountItem, {
              icon: _rewardPoint2x2.default,
              title: 'Điểm tích lũy',
              exu: true,
              point: objUser.rewardPoints
            }),
            _react2.default.createElement(_components.AccountItem, {
              link: '/quyen-loi-thanh-vien',
              icon: _rewardBenefit2x2.default,
              title: 'Quyền lợi thành viên'
            }),
            _support.Helper.isDev() && _react2.default.createElement(_components.AccountItem, {
              link: '/phuong-thuc-thanh-toan',
              customIconStyle: { height: 17, width: 22 },
              icon: _paymentListIcon3x2.default,
              title: 'Phương thức thanh toán'
            })
          ),
          _react2.default.createElement('div', { className: styles.breakView }),
          _react2.default.createElement(
            'div',
            { className: styles.accountLink },
            _react2.default.createElement(_components.AccountItem, {
              link: '/uu-dai-trai-nghiem',
              onClick: function onClick() {
                return _this.props.changeTab('allReward');
              },
              icon: _currentReward2x2.default,
              title: 'Ưu đãi hiện hành',
              customIconStyle: { height: 16, width: 28, marginLeft: -3 }
            }),
            _react2.default.createElement(_components.AccountItem, {
              link: '/uu-dai-toi',
              onClick: function onClick() {
                return _this.props.changeTab('myReward');
              },
              icon: _myVoucher2x2.default,
              title: 'Ưu đãi của tôi',
              customIconStyle: { height: 16, width: 28, marginLeft: -3 },
              leftArrow: '(' + (myVoucherAmount || 0) + ' \u01AFu \u0111\xE3i)'
            })
          ),
          _react2.default.createElement('div', { className: styles.breakView }),
          _react2.default.createElement(
            'div',
            { className: styles.accountLink },
            _react2.default.createElement(_components.AccountItem, {
              link: '/quan-ly-dat-cho',
              icon: _calendar2x2.default,
              title: 'Quản lý đặt chỗ'
            }),
            _react2.default.createElement(_components.AccountItem, {
              link: '/lich-su-hoat-dong',
              icon: _history2x2.default,
              title: 'Lịch sử hoạt động'
            })
          ),
          _react2.default.createElement('div', { className: styles.breakView }),
          _react2.default.createElement(
            'div',
            { className: styles.accountLink },
            _react2.default.createElement(_components.AccountItem, {
              extLink: 'https://apps.apple.com/us/app/lookme-business/id1436866121',
              icon: _app2x2.default,
              title: 'Ứng dụng cho chủ shop'
            }),
            _react2.default.createElement(_components.AccountItem, {
              link: '/gop-y',
              icon: _feedback2x2.default,
              title: 'Góp ý',
              customIconStyle: { height: 17 }
            }),
            _react2.default.createElement(_components.AccountItem, {
              link: '/tao-cua-hang',
              icon: _newShop2x2.default,
              title: 'Tạo shop mới'
            })
          ),
          _react2.default.createElement('div', { className: styles.breakView }),
          _this.renderPolicyItems(styles),
          _react2.default.createElement('div', { className: styles.breakView }),
          _react2.default.createElement(
            'div',
            { className: styles.accountLink },
            _react2.default.createElement(
              'div',
              {
                className: styles.accountItemSetting,
                onClick: function onClick() {
                  return _this.handleLogout();
                }
              },
              '\u0110\u0103ng xu\u1EA5t'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.version },
            _react2.default.createElement(
              'div',
              null,
              'Phi\xEAn b\u1EA3n \u1EE9ng d\u1EE5ng v',
              _package.version
            )
          )
        )
      );
    }, _this.renderNotLoggedIn = function (styles, avatarUrl) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.thumbnailContainer },
          _react2.default.createElement(
            'div',
            { className: styles.avatar },
            _react2.default.createElement('img', {
              src: avatarUrl,
              style: { backgroundImage: 'url:(' + avatarUrl + ')' },
              className: styles.avatarImg,
              onClick: function onClick() {
                return _this.props.pushState('/dang-nhap');
              }
            }),
            _react2.default.createElement(
              'div',
              { className: styles.userEmpty },
              _react2.default.createElement(
                'div',
                { className: styles.notLogin },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/dang-nhap' },
                  '\u0110\u0102NG NH\u1EACP'
                ),
                ' ngay \u0111\u1EC3 nh\u1EADn nhi\u1EC1u \u01B0u \u0111\xE3i t\u1EEB Lookme'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _this.renderPolicyItems(styles),
          _react2.default.createElement('div', { className: styles.breakView }),
          _react2.default.createElement(
            'div',
            { className: styles.accountLink },
            _react2.default.createElement(
              'div',
              { className: styles.accountLink },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/dang-nhap' },
                _react2.default.createElement(
                  'div',
                  { className: styles.accountItemSetting },
                  '\u0110\u0103ng nh\u1EADp'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.version },
            _react2.default.createElement(
              'div',
              null,
              'Phi\xEAn b\u1EA3n \u1EE9ng d\u1EE5ng v',
              _package.version
            )
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AccountMobile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.getMyReward();
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Account.scss');
      var _props = this.props,
          user = _props.user,
          myVoucherAmount = _props.MY_REWARD_LIST.number;

      var objRank = {},
          objUser = {};
      if (user) {
        objRank = user.objectRank || {};
        objUser = {
          picture: user.profile.picture,
          name: user.profile.name,
          rewardPoints: user.rewardPoints
        };
      }
      if (objRank.type) {
        objRank.imageRank = _Constant2.default.RANK[objRank.type].memberStar;
      }
      var avatarUrl = objUser.picture ? (0, _lib.getUrlImage)(objUser.picture) : _Constant.defaultAvatar;
      return _react2.default.createElement(
        'div',
        { className: styles.accountMobile },
        _react2.default.createElement(
          'div',
          { className: styles.accountInfo },
          user ? this.renderLoggedIn(styles, objUser, objRank, avatarUrl, myVoucherAmount) : this.renderNotLoggedIn(styles, avatarUrl)
        )
      );
    }
  }]);
  return AccountMobile;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  logout: _react.PropTypes.func,
  pushState: _react.PropTypes.func.isRequired,
  changeTab: _react.PropTypes.func,
  getMyReward: _react.PropTypes.func,
  MY_REWARD_LIST: _react.PropTypes.object
}, _temp2)) || _class);
exports.default = AccountMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/AccountManagement/Account.js
// module id = 1525
// module chunks = 0